/**
 * The browser's IANA zone, sent with every turn as `deviceTimeZone`. Without it the harness clock falls
 * back to the SITE timezone, which can differ from where the user is. The phones send the same field.
 */
export function browserTimeZone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}
